module.exports = __webpack_public_path__ + "static/img/kxxd.4fb977e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kxxd.jpg
// module id = vMFy
// module chunks = 4